(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const form = document.querySelector('.ff-contact__form');
    const submitButton = document.getElementById('contact-submit');

    if (form && submitButton) {
      form.addEventListener('submit', function() {
        // Add loading state
        submitButton.classList.add('is-loading');
        submitButton.disabled = true;
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    const productSection = document.querySelector('.ff-product');
    if (!productSection) {
      console.log('Product section not found');
      return;
    }

    const form = productSection.querySelector('[data-product-form]');
    const select = form?.querySelector('select[name="id"]');
    const priceEl = productSection.querySelector('[data-product-price]');
    const submitButton = productSection.querySelector('[data-product-submit]');
    const optionGroups = productSection.querySelectorAll('[data-option-position]');
    const qtyButtons = productSection.querySelectorAll('[data-qty-change]');
    const qtyInput = productSection.querySelector('.ff-product__qty-input');
    const mainImage = productSection.querySelector('[data-product-main] img');

    console.log('Quantity buttons found:', qtyButtons.length);
    console.log('Quantity input found:', qtyInput);

    const variants = form?.dataset.variants ? JSON.parse(form.dataset.variants) : [];

    const updateSubmitState = (available) => {
      if (!submitButton) return;
      submitButton.disabled = !available;
      const isPreorder = submitButton.textContent.includes('Pre-Order');
      if (available) {
        submitButton.textContent = isPreorder ? 'Pre-Order Now' : 'Add to Cart';
      } else {
        submitButton.textContent = 'Out of Stock';
      }
    };

    const updatePrice = (variantId) => {
      if (!select || !priceEl) return;
      const option = Array.from(select.options).find((opt) => opt.value === String(variantId));
      if (option && option.dataset.price) {
        priceEl.textContent = option.dataset.price;
      }
      if (option && option.dataset.available) {
        updateSubmitState(option.dataset.available === 'true');
      }
    };

    const getSelectedOptions = () => {
      return Array.from(optionGroups).map((group) => {
        const active = group.querySelector('.ff-product__option-value.is-active');
        return active ? active.dataset.optionValue : null;
      });
    };

    const findMatchingVariant = () => {
      const selections = getSelectedOptions();
      return variants.find((variant) => {
        return selections.every((value, index) => value === variant.options[index]);
      });
    };

    optionGroups.forEach((group) => {
      group.addEventListener('click', (event) => {
        const target = event.target.closest('[data-option-value]');
        if (!target) return;
        group.querySelectorAll('[data-option-value]').forEach((button) => {
          button.classList.remove('is-active');
        });
        target.classList.add('is-active');
        const match = findMatchingVariant();
        if (match && select) {
          select.value = match.id;
          updatePrice(match.id);
          if (match.featured_media && mainImage) {
            mainImage.src = match.featured_media.preview_image.src;
          }
        }
      });
    });

    if (select) {
      updatePrice(select.value);
    }

    // Quantity controls
    qtyButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        console.log('Button clicked:', button.dataset.qtyChange);
        if (!qtyInput) {
          console.log('Input not found!');
          return;
        }
        const change = parseInt(button.dataset.qtyChange) || 0;
        const currentValue = parseInt(qtyInput.value) || 1;
        const nextValue = Math.max(1, currentValue + change);
        console.log('Current:', currentValue, 'Change:', change, 'Next:', nextValue);
        qtyInput.value = nextValue;
      });
    });

    // Validate quantity input
    if (qtyInput) {
      qtyInput.addEventListener('input', (e) => {
        // Allow only numbers
        const cleaned = e.target.value.replace(/[^0-9]/g, '');
        if (cleaned === '' || parseInt(cleaned) < 1) {
          e.target.value = '1';
        } else {
          e.target.value = cleaned;
        }
      });

      qtyInput.addEventListener('blur', (e) => {
        // Ensure value is valid on blur
        if (e.target.value === '' || parseInt(e.target.value) < 1) {
          e.target.value = '1';
        }
      });
    }

    const thumbs = productSection.querySelectorAll('[data-media-id]');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!mainImage) return;
        const img = thumb.querySelector('img');
        if (img) {
          mainImage.src = img.src;
        }
        thumbs.forEach((button) => button.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
